function getAeolianTypeList () {
    return [
        {aeolianTypeId: 1, description: 'Dune'},
        {aeolianTypeId: 2, description: 'Sand Shadow'},
        {aeolianTypeId: 3, description: 'Sand Sheet'},
        {aeolianTypeId: 4, description: 'Deflation area'},
        {aeolianTypeId: 5, description: 'Unknown'}
    ]
}

function getDepositEstimateBasisList () {
    return [
        {depositEstimateBasisId: 1, description: 'Rough Guess'},
        {depositEstimateBasisId: 2, description: 'Shovel Test(s)'},
        {depositEstimateBasisId: 3, description: 'Excavation(s)'},
        {depositEstimateBasisId: 4, description: 'Road/Arroyo Cuts'},
        {depositEstimateBasisId: 5, description: 'Animal Burrows'},
        {depositEstimateBasisId: 6, description: 'Other Information'}
    ]
}

function getDepositionalTypeList () {
    return [
        {depositionalTypeId: 1, description: 'Aeolian'},
        {depositionalTypeId: 2, description: 'Alluvial'},
        {depositionalTypeId: 3, description: 'Colluvial'},
        {depositionalTypeId: 4, description: 'Bare Rock'},
        {depositionalTypeId: 5, description: 'Regolith'},
        {depositionalTypeId: 6, description: 'Not Applicable'},
        {depositionalTypeId: 7, description: 'Other'},
        {depositionalTypeId: 8, description: 'Unknown'}
    ]
}

function getTopographicSettingList () {
    return [
        {topographicSettingId: 1, description: 'Basin/Interior'},
        {topographicSettingId: 2, description: 'Foothill/Basin Margin'},
        {topographicSettingId: 3, description: 'Major River Terraces'},
        {topographicSettingId: 4, description: 'Mountain/Major Uplift'},
        {topographicSettingId: 5, description: 'Unknown'}
    ]
}

function getUniqueSettingList () {
    return [
        {uniqueSettingId: 1, description: 'Playa'},
        {uniqueSettingId: 2, description: 'Saddle/Pass'},
        {uniqueSettingId: 3, description: 'Arroyo/Cutbank'},
        {uniqueSettingId: 4, description: 'Cliff'},
        {uniqueSettingId: 5, description: 'Rockshelter'},
        {uniqueSettingId: 6, description: 'Cave'},
        {uniqueSettingId: 7, description: 'Spring'}
    ]
}

function getVegetationTypeList () {
    return [
        {vegetationTypeId: 1, description: 'Alpine'},
        {vegetationTypeId: 2, description: 'Spruce/Fir'},
        {vegetationTypeId: 3, description: 'Douglas-Fir'},
        {vegetationTypeId: 4, description: 'Lodgepole Pine'},
        {vegetationTypeId: 5, description: 'Ponderosa Pine'},
        {vegetationTypeId: 6, description: 'Aspen/Conifer'},
        {vegetationTypeId: 7, description: 'Oak'},
        {vegetationTypeId: 8, description: 'Juniper'},
        {vegetationTypeId: 9, description: 'Desert Shrub'},
        {vegetationTypeId: 10, description: 'Grassland'},
        {vegetationTypeId: 11, description: 'Sagebrush'},
        {vegetationTypeId: 12, description: 'Sand Dunes'},
        {vegetationTypeId: 13, description: 'Riparian'},
        {vegetationTypeId: 14, description: 'Cultivated'},
        {vegetationTypeId: 15, description: 'Unknown'},
        {vegetationTypeId: 16, description: 'Not Applicable'}
    ]
}

function getGeographicDivisionList () {
    return [
        {geographicDivisionId: 1, description: 'Absaroka Range'},
        {geographicDivisionId: 2, description: 'Bates Hole'},
        {geographicDivisionId: 3, description: 'Beartooth Mtns.'},
        {geographicDivisionId: 4, description: 'Bighorn Basin'},
        {geographicDivisionId: 5, description: 'Bridger Basin'},
        {geographicDivisionId: 6, description: 'Bighorn Mtns.'},
        {geographicDivisionId: 7, description: 'Black Hills Uplift'},
        {geographicDivisionId: 8, description: 'Casper Arch'},
        {geographicDivisionId: 9, description: 'Denver Basin'},
        {geographicDivisionId: 10, description: 'Ferris Mtns.'},
        {geographicDivisionId: 11, description: 'Fossil Basin'},
        {geographicDivisionId: 12, description: 'Granite Mtns.'},
        {geographicDivisionId: 13, description: 'Great Divide Basin'},
        {geographicDivisionId: 14, description: 'Green River Basin'},
        {geographicDivisionId: 15, description: 'Green Mtn.'},
        {geographicDivisionId: 16, description: 'Goshen Hole'},
        {geographicDivisionId: 17, description: 'Gros Ventre Range'},
        {geographicDivisionId: 18, description: 'Hanna-Carbon Basin'},
        {geographicDivisionId: 19, description: 'Hartville Uplift'},
        {geographicDivisionId: 20, description: 'Hoback Range'},
        {geographicDivisionId: 21, description: 'Jackson Hole'},
        {geographicDivisionId: 22, description: 'Kindt Basin'},
        {geographicDivisionId: 23, description: 'Laramie Basin'},
        {geographicDivisionId: 24, description: 'Laramie Mtns.'},
        {geographicDivisionId: 25, description: 'Madison Range'},
        {geographicDivisionId: 26, description: 'Medicine Bow Mtns.'},
        {geographicDivisionId: 27, description: 'N Laramie Basin Structures'},
        {geographicDivisionId: 28, description: 'Overthrust Belt'},
        {geographicDivisionId: 29, description: 'Owl Creek Mtns.'},
        {geographicDivisionId: 30, description: 'Powder River Basin'},
        {geographicDivisionId: 31, description: 'Rawlins Uplift'},
        {geographicDivisionId: 32, description: 'Rock Springs Uplift'},
        {geographicDivisionId: 33, description: 'Salt River Range'},
        {geographicDivisionId: 34, description: 'Sierra Madre Mtns.'},
        {geographicDivisionId: 35, description: 'Seminoe Mtns.'},
        {geographicDivisionId: 36, description: 'Shirley Basin'},
        {geographicDivisionId: 37, description: 'Shirley Mtns.'},
        {geographicDivisionId: 38, description: 'Snake River Range'},
        {geographicDivisionId: 39, description: 'Sublette Range'},
        {geographicDivisionId: 40, description: 'Star Valley'},
        {geographicDivisionId: 41, description: 'Teton Range'},
        {geographicDivisionId: 42, description: 'Tunp Range'},
        {geographicDivisionId: 43, description: 'Washakie Basin'},
        {geographicDivisionId: 44, description: 'Washakie Range'},
        {geographicDivisionId: 45, description: 'Wind River Basin'},
        {geographicDivisionId: 46, description: 'Wind River Range'},
        {geographicDivisionId: 47, description: 'Yellowstone Volcanic Plateau'},
        {geographicDivisionId: 48, description: 'Unknown'}
    ]
}

function getSiteSetting (http, id) {
    return http.get('/SiteSetting/Get?investigativeHistoryId=' + id)
}
function putSiteSetting (http, dto) {
    return http.put('/SiteSetting/', dto)
}
function searchSiteSetting (http, searchDto) {
    return http.post('/SiteSetting/Search', searchDto)
}

function getAeolianType (http, id) {
    return http.get('/SiteSetting/GetSiteSettingAeolianType?id=' + id)
}

function searchAeolianType (http, searchDto) {
    return http.post('/SiteSetting/SearchSiteSettingAeolianType', searchDto)
}

function getSiteSettingDepositEstimateBasis (http, id) {
    return http.get('/SiteSetting/GetSiteSettingDepositEstimateBasis?id=' + id)
}

function searchSiteSettingDepositEstimateBasis (http, searchDto) {
    return http.post('/SiteSetting/searchSiteSettingDepositEstimateBasis', searchDto)
}

function getSiteSettingDepositionalType (http, id) {
    return http.get('/SiteSetting/GetSiteSettingDepositionalType?id=' + id)
}

function searchSiteSettingDepositionalType (http, searchDto) {
    return http.post('/SiteSetting/searchSiteSettingDepositionalType', searchDto)
}

function getSiteSettingTopography (http, id) {
    return http.get('/SiteSetting/GetSiteSettingTopography?id=' + id)
}

function searchSiteSettingTopography (http, searchDto) {
    return http.post('/SiteSetting/searchSiteSettingTopography', searchDto)
}

function getSiteSettingUniqueSetting (http, id) {
    return http.get('/SiteSetting/GetSiteSettingUniqueSetting?id=' + id)
}

function searchSiteSettingUniqueSetting (http, searchDto) {
    return http.post('/SiteSetting/searchSiteSettingUniqueSetting', searchDto)
}

function getSiteSettingVegetation (http, id) {
    return http.get('/SiteSetting/GetSiteSettingVegetation?id=' + id)
}

function searchSiteSettingVegetation (http, searchDto) {
    return http.post('/SiteSetting/searchSiteSettingVegetation', searchDto)
}

function getSiteSettingDivision (http, id) {
    return http.get('/SiteSetting/GetSiteSettingDivision?id=' + id)
}

function searchSiteSettingDivision (http, searchDto) {
    return http.post('/SiteSetting/searchSiteSettingDivision', searchDto)
}

export default {
    getAeolianTypeList: getAeolianTypeList,
    getDepositEstimateBasisList: getDepositEstimateBasisList,
    getDepositionalTypeList: getDepositionalTypeList,
    getTopographicSettingList: getTopographicSettingList,
    getUniqueSettingList: getUniqueSettingList,
    getVegetationTypeList: getVegetationTypeList,
    getGeographicDivisionList: getGeographicDivisionList,

    getSiteSetting: getSiteSetting,
    putSiteSetting: putSiteSetting,
    searchSiteSetting: searchSiteSetting,

    getAeolianType: getAeolianType,
    searchAeolianType: searchAeolianType,

    getSiteSettingDepositEstimateBasis: getSiteSettingDepositEstimateBasis,
    searchSiteSettingDepositEstimateBasis: searchSiteSettingDepositEstimateBasis,

    getSiteSettingDepositionalType: getSiteSettingDepositionalType,
    searchSiteSettingDepositionalType: searchSiteSettingDepositionalType,

    getSiteSettingTopography: getSiteSettingTopography,
    searchSiteSettingTopography: searchSiteSettingTopography,

    getSiteSettingUniqueSetting: getSiteSettingUniqueSetting,
    searchSiteSettingUniqueSetting: searchSiteSettingUniqueSetting,

    getSiteSettingVegetation: getSiteSettingVegetation,
    searchSiteSettingVegetation: searchSiteSettingVegetation,

    getSiteSettingDivision: getSiteSettingDivision,
    searchSiteSettingDivision: searchSiteSettingDivision

}



// WEBPACK FOOTER //
// ./src/services/siteForm/siteSettingService.js